const logotext = "SAPHENA'S";
const meta = {
    title: "Saphena's Luxury Enterprise",
    description: "",
};

const introdata = {
    title: "Hello! Thank you for visiting:",
    animated: {
        first: "Saphena's Luxury Enterprise...",
        second: "The Number one Interior Design & Decor Company in Nigeria...",
        third: "Where Luxurious living is made affordable.",
    },
    description: "Saphena's Luxury Enterprise is a highly esteemed Interior Design Consultancy and Project Management Agency, specializing in interior products procurement and supply. Our company provides comprehensive interior design and decor services to corporate, residential, and retail clients. With a team of skilled, imaginative, and dedicated professionals, we deliver tailored design solutions that are truly unique. Regardless of the project's scale, we approach each client's requirements on an individual basis, ensuring personalized attention. Moreover, we pride ourselves on delivering cost-effective interior design solutions without compromising on quality.",
    your_img_url: "",
};

const dataabout = {
    // title: "abit about my self",
    aboutme: "At 'Saphena's Luxury Enterprise', our services are individually tailored to the needs of each client. Our designs are always impressive, owning to our attention to detail emphatic understanding of our clients' tastes and ambitions, as well as giving due consideration to time and budget constraints. We work closely with our clients because we recognize that different clients have different values and lifestyle and all these have to be factored into the design. These insights guide us in our quest to create an environment that is both functional and aesthetically pleasing.",
};
const worktimeline = [{
        jobtitle: "Designer of week",
        where: "YAdfi",
        date: "2020",
    },
    {
        jobtitle: "Designer of week",
        where: "Jamalya",
        date: "2019",
    },
    {
        jobtitle: "Designer of week",
        where: "ALquds",
        date: "2019",
    },
];

const skills = [{
        name: "Python",
        value: 90,
    },
    {
        name: "Djano",
        value: 85,
    },
    {
        name: "Javascript",
        value: 80,
    },
    {
        name: "React",
        value: 60,
    },
    {
        name: "Jquery",
        value: 85,
    },
];

const services = [{
        title: "General Interior Design & Decor",
        description: "As an interior design company at the forefront of market trends, we have a team dedicated to all kinds of interior development projects ranging from: SPACE PLANNING, 2D/3D RENDERING, GENERAL RENOVATIONS, PROJECT MANAGEMENT, INTERIOR DECORATION, ITEM PROCUREMENT.",
    },
    {
        title: "Residential Interior Design",
        description: "We are focused on creating spaces that are both functional and aesthetically appealing. Since we have different kinds of buildings, it makes sense that we have different kinds of interior design concepts for different kinds of people.",
    },
    {
        title: "Office Design and Set Up",
        description: "To create an office design, good planning is essential. A well-planned office design improves productivity and contributes to the well-being of employees. Our office designs reflect your company and how you like to work, both internally and with customers.",
    },
    {
        title: "Hotel Design and Set Up",
        description: "We specialize in creating bespoke solutions for hotels, ranging from the whole look and feel of the hotel, to beds and beddings.",
    },
    {
        title: "Floor Solutions",
        description: "We offer you perfect solutions in interior and exterior flooring such as: TILES, MARBLES, GRANITES; WOODEN & VINYL FLOORS; CARPET RUGS; EXPOXY FLOORS; ARTIFICIAL GRASS; INTERLOCKING, STAMP FLOORS.",
    },
    {
        title: "Wall Finish",
        description: "We enhance the interior or exterior look of your structure using wall finish solutions such as: SCREEDING, WALL NICHE, WAINSCOTING, WALL CLADDING, WALL PRINTS, 3D PANELS, WALLPAPER,DRYWALL/FALSE WALL, TV/MEDIA WALL and PAINTING.",
    },
    {
        title: "Ceiling Decor",
        description: "We offer distinct and unique ceiling finishes that deliver that 'wow' effect while staying true to the lifestyles and budgets of our clients. Some of our ceiling finish solutions include: POP CEILING, STRETCH CEILING, PERGOLA.",
    },
    {
        title: "Window Treatment",
        description: "Window coverings can be functional, purely decorative, or strike a balance between the two, depending on your space and the amount of natural light you receive and prefer. Whether it's classic curtains, window blinds, modern coverings, Roman shades, or laidback shutters; we will source the material of your choice, produce and install it within a twinkle of an eye. We also offer a motorised feature providing you with a way to operate your blinds easily. With our motorized curtains, and blinds using remote control, you can control all your curtains and blinds easily with the click of a button.",
    },
    {
        title: "Furniture",
        description: "We source or design, craft and fabricate our furniture with the goal of creating pieces that you'll love having in your space. Furniture such as: BEDS, SOFAS, TABLES, WARDROBES, CABINETS.",
    },
];

const dataportfolio = [{
        img: "https://i.pinimg.com/236x/65/2a/a4/652aa43665a79aac13772cfd34b33033.jpg",
        description: "PAINTING",
        link: "#",
    },
    {
        img: "https://i.pinimg.com/236x/8b/77/76/8b77764266911eea371841fb7c648c75.jpg",
        description: "OFFICE SET-UP",
        link: "#",
    },
    {
        img: "https://i.pinimg.com/236x/6f/4c/69/6f4c69a5f0cfceafbece2e4140328395.jpg",
        description: "GENERAL HOME DECOR",
        link: "#",
    },
    {
        img: "https://i.pinimg.com/236x/c3/f2/f7/c3f2f7e31a807d6dcb42dbacb66e6556.jpg",
        description: "GENERAL HOME DECOR",
        link: "#",
    },
    {
        img: "https://i.pinimg.com/236x/9b/62/e9/9b62e9f4ab24b2a0a25bc2dc6233f316.jpg",
        description: "GENERAL HOME DECOR",
        link: "#",
    },
    {
        img: "https://i.pinimg.com/236x/53/d4/6e/53d46ee438b6796691aa8f291ed1c389.jpg",
        description: "TILING",
        link: "#",
    },

    {
        img: "https://i.pinimg.com/236x/f9/0c/88/f90c88ff2dc78029340f1754d7ca7a8e.jpg",
        description: "WOODEN & VINYL FLOORS",
        link: "#",
    },
    {
        img: "https://i.pinimg.com/236x/92/39/b5/9239b5fc9def6382082d5e7bd8546775.jpg",
        description: "TV/MEDIA WALL",
        link: "#",
    },
    {
        img: "https://i.pinimg.com/236x/2a/fb/19/2afb195de2a0498f33a170edff34f39b.jpg",
        description: "ARTIFICIAL GRASS",
        link: "#",
    },
    {
        img: "https://i.pinimg.com/236x/88/96/b8/8896b81e822311488c1341beb319f1c8.jpg",
        description: "EPOXY FLOORS",
        link: "#",
    },
    {
        img: "https://i.pinimg.com/236x/a6/bc/70/a6bc70beb4cb1f9baf34722c310c120b.jpg",
        description: "INTERLOCKING",
        link: "#",
    },
    {
        img: "https://i.pinimg.com/236x/b2/f1/c2/b2f1c289a5782ef3df9b73f9b745dbb8.jpg",
        description: "WALL PRINTS",
        link: "#",
    },
    {
        img: "https://i.pinimg.com/236x/f5/17/a9/f517a9bdf471cb88cf2f790f346178af.jpg",
        description: "STRETCH CEILING",
        link: "#",
    },
    {
        img: "https://i.pinimg.com/236x/17/e0/35/17e0357c9e86da18f926c7ef3963d872.jpg",
        description: "P O P CEILING",
        link: "#",
    },
    {
        img: "https://i.pinimg.com/236x/91/d8/45/91d84561477aa489e0d57e10fbca603c.jpg",
        description: "WALLPAPER",
        link: "#",
    },
    {
        img: "https://i.pinimg.com/236x/e3/06/0d/e3060de220b4651c79343c916a87112c.jpg",
        description: "WALL FINISH",
        link: "#",
    },
    {
        img: "https://i.pinimg.com/236x/44/07/60/44076029025821b1664a7cf30b33518e.jpg",
        description: "3D PANEL",
        link: "#",
    },
    {
        img: "https://i.pinimg.com/236x/af/44/24/af44246fc13dbfd384c0ed12e5601f8c.jpg",
        description: "WALL NICHE",
        link: "#",
    },
    {
        img: "https://i.pinimg.com/236x/5b/fb/f3/5bfbf3ad0f3c780addd660763007280e.jpg",
        description: "THANK YOU FOR VISTING OUR WEBSITE!",
        link: "#",
    },
];

const contactConfig = {
    YOUR_EMAIL: "nkemkimberly6@gmail.com",
    YOUR_FONE: "07065522580",
    description: "Office Address: No. 1 Akesan Plaza, Lasu Isheri Express Road, Akesan. ",
    // creat an emailjs.com account 
    // check out this tutorial https://www.emailjs.com/docs/examples/reactjs/
    YOUR_SERVICE_ID: "service_id",
    YOUR_TEMPLATE_ID: "template_id",
    YOUR_USER_ID: "user_id",
};

const socialprofils = {
    instagram: "https://instagram.com/saphenas_interiors?igshid=MzRlODBiNWFlZA==",
    facebook: "https://www.facebook.com/nkemkimberly.onyemehian?mibextid=ZbWKwL",
    whatsapp: "https://api.whatsapp.com/send/?phone=%2B2347065522580&text&type=phone_number&app_absent=0",
};
export {
    meta,
    dataabout,
    dataportfolio,
    worktimeline,
    skills,
    services,
    introdata,
    contactConfig,
    socialprofils,
    logotext,
};